export { SIDE_PANEL_CATEGORY_ACC } from '../constant';
export { SIDE_PANEL_CATEGORY_ENT } from '../constant';
export { SIDE_PANEL_CATEGORY_RLE } from '../constant';
export { SIDE_PANEL_CATEGORY_USR } from '../constant';

export const MAX_RECORDS_TO_FETCH = 10;
export const PROMISE_FULLFILLED = 'fulfilled';
export const FORCED_CANCELLATION = 'CanceledError: Forced Cancellation';

export { TAB_SUMMARY } from '../constant';
export { TAB_HISTORY } from '../constant';
export { TAB_PRIVILEGE } from '../constant';
export { TAB_ENTITLEMENT } from '../constant';
export { TAB_CHILDREN } from '../constant';
export { TAB_DEPENDENT } from '../constant';
export { TAB_SOD } from '../constant';
export { TAB_MENU } from '../constant';

export const DEFAULT_COUNT_ACCORDIANS_OPEN = 1;

export const sodRiskButtonColor = {
  Medium: 'warning',
  High: 'critical',
  Critical: 'critical',
};
